import axios from 'axios';

const api = axios.create({
  baseURL: 'https://service-01.commerceplus.info/apiv2',
  headers: {
    post: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  },
});

api.defaults.timeout = 120000;

api.interceptors.response.use(
  function (response) {
    if (
      response &&
      response.data &&
      response.data.code &&
      response.data.code === '401'
    ) {
      localStorage.removeItem('@milvio:token');
    }
    return response;
  },
  function (error) {
    if (error.response.status === 401) {
      localStorage.removeItem('@milvio:token');
    } else {
      return Promise.reject(error);
    }
  },
);

export default api;
